import { createSlice } from "@reduxjs/toolkit";
import { getEsignContentAPI, getTermsAndConditionsAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getEsignContentSlice = createSlice({
  name: "getEsignContent",
  initialState: data,
  reducers: {
    getEsignContentSliceInfo(state) {
      state.isLoading = true;
    },
    getEsignContentSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getEsignContentSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getEsignContentSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getEsignContentHandler = (data) => async (dispatch) => {
  try {
    dispatch(getEsignContentSliceAction.getEsignContentSliceInfo());
    const response = await getEsignContentAPI(data);
    dispatch(
      getEsignContentSliceAction.getEsignContentSliceSuccess(
        response,
      ),
    );
  } catch (e) {
    dispatch(
      getEsignContentSliceAction.getEsignContentSliceFailure(e),
    );
  }
};
export default getEsignContentSlice.reducer;
export const getEsignContentSliceAction =
  getEsignContentSlice.actions;
